<div class="rankings-anon-form-modal" [ngClass]="{'show animation-fade-slide-in': showAnonEmailUnlockForm}">
  <div class="anon-unlock-form-cont">
    <ng-container *ngIf="formTitle">
      <div class="form-content" [ngClass]="{'hide-form':state !== 'idle'}">
        <h1><img src="https://2364596.fs1.hubspotusercontent-na1.net/hubfs/2364596/lock-icon.png"
            style="height: auto; max-width: 24px; width: 24px; margin: 0px 7px 0px 0px;" alt="lock-icon" width="24"
            height="24" loading="lazy">Access {{ formTitle | capitalizeWords }}</h1>
        To continue to the <strong>{{ formTitle }}</strong>, enter your email address.
        <div class="hubspot-form anon-unlock-form"></div>
      </div>
      <div class="submitting-overlay" *ngIf="state === 'submitting'">
        <div class="spinner"></div>
      </div>
      <div class="submitted" *ngIf="state === 'submitted'">
        Thanks, your email has been submitted.
      </div>
    </ng-container>

    <ng-container *ngIf="!formTitle">
      <div class="hubspot-form anon-unlock-form"></div>
    </ng-container>

  </div>
</div>